import { render, staticRenderFns } from "./studenErrorQuestion.vue?vue&type=template&id=dae3359c&scoped=true"
import script from "./studenErrorQuestion.vue?vue&type=script&lang=js"
export * from "./studenErrorQuestion.vue?vue&type=script&lang=js"
import style0 from "./studenErrorQuestion.vue?vue&type=style&index=0&id=dae3359c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae3359c",
  null
  
)

export default component.exports